export const mainPage = {
  type: 'Wybierz typ',
  subtype: 'Wybierz podtyp',
  brand: 'Wybierz markę',
  brandModel: 'Wybierz model',
}
